import React from "react";
import Container from "@mui/material/Container";
import ErrorComponent from "../component/ErrorComponent";

const AdminDashboard = () => {
  React.useEffect(() => {
    console.log("Use Effect Dashboard");
  }, []);
  return (
    <Container sx={{ marginTop: "100px", marginBottom: "25px" }}>
      <ErrorComponent message="This is an Admin Login feature and is not accessible for general use." />
    </Container>
  );
};

export default AdminDashboard;
